import { render, staticRenderFns } from "./RespostaRadio.vue?vue&type=template&id=199f2e02"
import script from "./RespostaRadio.vue?vue&type=script&lang=js"
export * from "./RespostaRadio.vue?vue&type=script&lang=js"
import style0 from "./RespostaRadio.vue?vue&type=style&index=0&id=199f2e02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports